import { inventorySlotQueryKeys as e } from "./useInventorySlotQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { inventorySlotsApi as n } from "@maat/api-main";
//#region src/inventorySlots/useInventorySlotsQuery.ts
var r = (r, i, a) => t({
	queryKey: e.host(r, i, a),
	queryFn: () => n.listSlots(r, i, a),
	enabled: !!i && !!a
});
//#endregion
export { r as useInventorySlotsQuery };
